/**
 * Progressive selection highlights — Ant Design semantic fills (cyan-2 / purple-2 / polar green-2)
 * with darker outlines for Mapbox line layers and pins.
 */
export const SEL_COUNTRY_FILL = '#D2E9EA';
export const SEL_COUNTRY_LINE = '#08979c';
export const SEL_REGION_FILL = '#EFDBFF';
export const SEL_REGION_LINE = '#722ed1';
export const SEL_DISTRICT_FILL = '#D9F7BE';
export const SEL_DISTRICT_LINE = '#389e0d';
export const SEL_LOCALITY_FILL = '#52c41a';
export const SEL_LOCALITY_LINE = '#389e0d';

/** Gray used for search-preview outlines (instead of per-type color). */
export const SEARCH_PREVIEW_LINE_COLOR = '#8c8c8c';

export const SOURCE_ADM0 = 'ow-gb-adm0';
export const SOURCE_ADM1 = 'ow-gb-adm1';
export const SOURCE_ADM2 = 'ow-gb-adm2';
export const SOURCE_ADM3 = 'ow-gb-adm3';

export const LAYER_ADM0_FILL = 'ow-gb-adm0-fill';
export const LAYER_ADM0_LINE = 'ow-gb-adm0-line';
export const LAYER_ADM1_FILL = 'ow-gb-adm1-fill';
export const LAYER_ADM1_LINE = 'ow-gb-adm1-line';
export const LAYER_ADM2_FILL = 'ow-gb-adm2-fill';
export const LAYER_ADM2_LINE = 'ow-gb-adm2-line';
export const LAYER_ADM3_FILL = 'ow-gb-adm3-fill';
export const LAYER_ADM3_LINE = 'ow-gb-adm3-line';
export const LAYER_HOVER_ADM0 = 'ow-gb-hover-adm0-line';
export const LAYER_HOVER_ADM1 = 'ow-gb-hover-adm1-line';
export const LAYER_HOVER_ADM2 = 'ow-gb-hover-adm2-line';
export const LAYER_HOVER_ADM3 = 'ow-gb-hover-adm3-line';

export const LAYER_SEL_ADM0_FILL = 'ow-gb-adm0-selected-fill';
export const LAYER_SEL_ADM0_LINE = 'ow-gb-adm0-selected-line';
export const LAYER_SEL_ADM1_FILL = 'ow-gb-adm1-selected-fill';
export const LAYER_SEL_ADM1_LINE = 'ow-gb-adm1-selected-line';
export const LAYER_SEL_ADM2_FILL = 'ow-gb-adm2-selected-fill';
export const LAYER_SEL_ADM2_LINE = 'ow-gb-adm2-selected-line';
export const LAYER_SEL_ADM3_FILL = 'ow-gb-adm3-selected-fill';
export const LAYER_SEL_ADM3_LINE = 'ow-gb-adm3-selected-line';

export const SOURCE_SEL_MARKERS = 'ow-gb-sel-markers';
export const LAYER_SEL_MARKERS_REGION = 'ow-gb-sel-marker-region';
export const LAYER_SEL_MARKERS_DISTRICT = 'ow-gb-sel-marker-district';

export const SOURCE_STORED = 'ow-gb-stored';
export const LAYER_STORED_FILL = 'ow-gb-stored-fill';
export const LAYER_STORED_LINE = 'ow-gb-stored-line';

/** Search dropdown preview outline (not part of saved selection). */
export const SOURCE_SEARCH_PREVIEW = 'ow-gb-search-preview';
export const LAYER_SEARCH_PREVIEW_LINE = 'ow-gb-search-preview-line';

export const HOVER_FILTER_NONE = '__ow_no_hover__';
export const SELECTION_FILTER_NONE = '__ow_gb_sel_none__';

/**
 * Mapbox queryRenderedFeatures only sees draws that hit the framebuffer; fill-opacity 0 is often not
 * "rendered", so center picking for active ISO returned nothing and ADM1/ADM2 never fetched (e.g. IND).
 * Keep this tiny so polygons stay visually "invisible" but queryable.
 */
export const PICK_TARGET_FILL_OPACITY = 0.008;

/** Lower thresholds so states/counties load and prioritize earlier when picking. */
export const ZOOM_ADM1 = 2;
export const ZOOM_ADM2 = 3;
export const ZOOM_ADM3 = 8;

/** Parallelism for manifest / per-country ADM0 bootstrap fetches. */
export const FETCH_CONCURRENCY = 4;
